import { render, staticRenderFns } from "./UserRoleDetailInput.vue?vue&type=template&id=6a07ee26&scoped=true&"
import script from "./UserRoleDetailInput.vue?vue&type=script&lang=js&"
export * from "./UserRoleDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleDetailInput.vue?vue&type=style&index=0&id=6a07ee26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a07ee26",
  null
  
)

export default component.exports